import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { useNavigate } from 'react-router-dom';
import Loader from './loader';

const ErrorHandlingComponent = ({ err }) => {
  const navigate = useNavigate();
  const callback = ''; // Optional callback function
  const [isLoading, setIsLoading] = useState(false);

  const catchHandler = () => {
    if (!err || !err.response || typeof err.response.status === 'undefined') {
      showSAlert('An unknown error occurred', 'error', callback);
      return;
    }

    const { status, data } = err.response;

    switch (status) {
      case 0:
        showSAlert('Remote server cannot be reached', 'error', callback);
        break;

      case 400:
        if (data?.detail) {
          showSAlert(data.detail, 'error', callback);
        } else {
          showSAlert(data?.message || 'Bad Request', 'error', callback);
          if (data?.content) {
            showSAlert(data.content, 'error', callback);
          }
        }
        break;

      case 401:
        localStorage.clear();
        navigate('/');
        break;

      case 403:
        if (data?.detail) {
          showSAlert(data.detail, 'error', callback);
        } else {
          showSAlert(data?.content || 'Forbidden', 'error', callback);
        }
        break;

      case 404:
      case 409:
        showSAlert(data?.message || 'Something went wrong', 'error', callback);
        break;

      default:
        showSAlert('An unexpected error occurred', 'error', callback);
        break;
    }
  };

  const showSAlert = (message, type, callback) => {
    Swal.fire('', message, type);
    if (callback && typeof callback === 'function') {
      callback();
    }
  };

  useEffect(() => {
    setIsLoading(true);
    catchHandler();
    setIsLoading(false);
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  return null;
};

export default ErrorHandlingComponent;
